import _ from 'lodash';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import DropDown from 'components/elements/atoms/DropDown/DropDown';

import './Users.scss';
import { ICONS, Icon } from 'components/Icons';
import moment from 'moment';
import Checkbox from 'components/elements/atoms/Checkbox';
import ReactSwitch from 'react-switch';

const Roles = [
  { label: 'Community', value: 'community' },
  { label: 'Creator', value: 'creator' },
  { label: 'Curator', value: 'curator' },
  { label: 'Student', value: 'student' },
  { label: 'Teacher', value: 'teacher' },
  { label: 'Parent', value: 'parent' },
  { label: 'School Admin', value: 'schoolAdmin' },
  { label: 'Admin', value: 'admin' },
];
const RoleStatuses = [
  { label: 'Activated', value: 'activated' },
  { label: 'Inactive', value: 'inactive' },
];

export default function ManageUser({
  user,
  handleSave,
  getUserExtensionStatus,
  onClose,
  schoolsOptions,
  actions,
}) {
  const [roles, setRoles] = useState(user.profile.roles);
  const [isLoading, setIsLoading] = useState(true);
  const [extensionStatus, setExtensionStatus] = useState(null);
  const [schools, setSchools] = useState(user.schools ? [...user.schools] : []);
  const [vocabularySubscribed, setVocabularySubscribed] = useState(
    user.vocabularySubscribed || false,
  );
  const [isTester, setIsTester] = useState(user.isTester || false);

  useEffect(() => {
    getUserExtensionStatus(user.username)
      .then((response) => setExtensionStatus(response))
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, [user.username]);

  const updateRole = (field, value, index) => {
    setRoles((roles) => {
      const updatedRoles = _.cloneDeep(roles);

      const role = updatedRoles[index];
      role[field] = value;

      return updatedRoles;
    });
  };

  const updateSchool = (field, value, index) => {
    setSchools((schools) => {
      const updatedSchools = _.cloneDeep(schools);
      updatedSchools[index][field] = value;
      return updatedSchools;
    });
  };

  const selectedRoles = roles.map((r) => r.type);
  const rolesOptions = Roles.filter((r) => !selectedRoles.includes(r.value));

  const showRole = (role, index) => {
    const selectedRole = Roles.find((r) => r.value === role.type);
    const selectedRoleStatus = RoleStatuses.find(
      (r) => r.value === role.status,
    );

    return (
      <tr>
        <td>
          <DropDown
            value={selectedRole || null}
            onChange={(selectedOption) =>
              updateRole('type', selectedOption.value, index)
            }
            options={[...(selectedRole ? [selectedRole] : []), ...rolesOptions]}
          />
        </td>
        <td>
          <DropDown
            value={selectedRoleStatus || null}
            onChange={(selectedOption) =>
              updateRole('status', selectedOption.value, index)
            }
            options={RoleStatuses}
          />
        </td>
        <td>
          <DropDown
            value={{ label: role.level || 1, value: role.level || 1 }}
            onChange={(selectedOption) =>
              updateRole('level', selectedOption.value, index)
            }
            options={[
              { label: 1, value: 1 },
              { label: 2, value: 2 },
              { label: 3, value: 3 },
              { label: 4, value: 4 },
              { label: 5, value: 5 },
              { label: 6, value: 6 },
            ]}
          />
        </td>
        <td
          className="cursor-pointer"
          onClick={() => {
            setRoles((roles) => {
              const updatedRoles = _.cloneDeep(roles);

              updatedRoles.splice(index, 1);

              return updatedRoles;
            });
          }}
        >
          <Icon className="mt-3" icon={ICONS.DELETE} />
        </td>
      </tr>
    );
  };

  const showSchool = (school, index) => {
    return (
      <tr key={index}>
        <td>
          <DropDown
            value={{ value: school.id, label: school.name }}
            onChange={(selectedOption) => {
              updateSchool('id', selectedOption.value, index);
              updateSchool('name', selectedOption.label, index);
            }}
            options={schoolsOptions}
          />
        </td>
        <td className="text-center">
          <Checkbox
            checked={school.isVerified}
            handleChange={(e) => {
              console.log(e.target.checked);
              updateSchool('isVerified', e.target.checked, index);
            }}
          ></Checkbox>
        </td>
        <td
          className="cursor-pointer"
          onClick={() => {
            setSchools((schools) => {
              const updateSchools = _.cloneDeep(schools);
              updateSchools.splice(index, 1);
              return updateSchools;
            });
          }}
        >
          <Icon className="mt-3" icon={ICONS.DELETE} />
        </td>
      </tr>
    );
  };

  const openUrl = (sourceUrl) => {
    window.open(sourceUrl, '_blank').focus();
  };

  const showExtensionStatus = () => {
    if (isLoading) {
      return (
        <div
          className="fa fa-spin fa-spinner text-primary my-4"
          style={{ fontSize: '24px' }}
        />
      );
    }

    return (
      <React.Fragment>
        <tr>
          <td className="font-weight-600">Last Status Date:</td>
          <td>
            {extensionStatus && extensionStatus.lastLoggedDate
              ? extensionStatus.lastLoggedDate
              : '-'}
          </td>
        </tr>
        {/* <tr>
          <td className="font-weight-600">Pinned:</td>
          <td>{extensionStatus && extensionStatus.isPinned ? 'Yes' : 'No'}</td>
        </tr> */}
        <tr>
          <td className="font-weight-600">Last Logged Article:</td>
          <td>
            {extensionStatus && extensionStatus.lastLoggedArticle ? (
              <span
                className="av-blue cursor-pointer"
                onClick={() =>
                  openUrl(extensionStatus.lastLoggedArticle.sourceURL)
                }
              >
                {extensionStatus.lastLoggedArticle.sourceTitle}
              </span>
            ) : (
              '-'
            )}
          </td>
        </tr>
        <tr>
          <td className="font-weight-600">Last Logged Article At:</td>
          <td>
            {extensionStatus && extensionStatus.lastLoggedArticle
              ? moment(extensionStatus.lastLoggedArticle.createdAt).format(
                  'YYYY-MM-DD',
                )
              : '-'}
          </td>
        </tr>
      </React.Fragment>
    );
  };

  const showExtensions = (typeOfAction, inactiveTypeOfAction) => {
    const siteInfo = user.siteInfo;

    if (
      !siteInfo ||
      !Array.isArray(siteInfo.extensions) ||
      siteInfo.extensions.length === 0
    ) {
      return null;
    }

    const latestExtensions = siteInfo.extensions.sort((ext2, ext1) => {
      return moment(ext2.time).isAfter(ext1.time) ? -1 : 1;
    });

    const actionExtensions = latestExtensions.filter(
      (ext) =>
        ext &&
        ext[typeOfAction] &&
        ext[typeOfAction].time &&
        (!ext[typeOfAction][inactiveTypeOfAction] ||
          moment(ext[typeOfAction][inactiveTypeOfAction]).isBefore(
            ext[typeOfAction].time,
          )),
    );

    if (actionExtensions.length === 0) {
      return null;
    }

    return actionExtensions
      .filter(
        (extension) => typeof extension === 'string' || extension.extension,
      )
      .map((extension) => {
        if (typeof extension === 'string') {
          return extension;
        }

        return extension.extension;
      })
      .join(', ');
  };

  const showExtensionVersions = () => {
    const siteInfo = user.siteInfo;

    if (
      !siteInfo ||
      !Array.isArray(siteInfo.extensions) ||
      siteInfo.extensions.length === 0
    ) {
      return null;
    }

    return siteInfo.extensions
      .filter((extension) => extension && extension.version)
      .map((extension) => {
        return extension.version;
      })
      .join(', ');
  };

  return (
    <Modal show className="manage-user-modal">
      <Modal.Header closeButton onHide={() => onClose()}>
        <Modal.Title>Manage User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table>
          <tbody>
            <tr>
              <td className="font-weight-600">Username:</td>
              <td>{user.username}</td>
            </tr>
            <tr>
              <td className="font-weight-600">Name:</td>
              <td>{`${user.profile.firstName} ${user.profile.lastName}`}</td>
            </tr>
            <tr>
              <td className="font-weight-600">Email:</td>
              <td>{user.email}</td>
            </tr>
            <tr>
              <td className="font-weight-600">Created on:</td>
              <td>{moment(user.createdAt).format('MM-DD-YYYY HH:mm:ss')}</td>
            </tr>
            <tr>
              <td className="font-weight-600">Sign up:</td>
              <td>
                {user.siteInfo && user.siteInfo.signUpBrowser
                  ? user.siteInfo.signUpBrowser
                  : '-'}
              </td>
            </tr>
            <tr>
              <td className="font-weight-600">Verify email:</td>
              <td>
                {user.siteInfo && user.siteInfo.verificationBrowser
                  ? user.siteInfo.verificationBrowser
                  : '-'}
              </td>
            </tr>
            <tr>
              <td className="font-weight-600">Setup account:</td>
              <td>
                {user.siteInfo && user.siteInfo.setupAccountBrowser
                  ? user.siteInfo.setupAccountBrowser
                  : '-'}
              </td>
            </tr>
            <tr>
              <td className="font-weight-600">Enable Vocabulary</td>
              <td>
                <ReactSwitch
                  offColor="#65737b"
                  offHandleColor="#A4B4BD"
                  onColor="#d5e7f4"
                  onHandleColor="#1286C8"
                  width={30}
                  height={16}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  checked={vocabularySubscribed}
                  onChange={(checked) => {
                    actions.changeSubscriptionStatus(
                      user._id,
                      'user',
                      checked ? 'active' : 'canceled',
                    );
                    setVocabularySubscribed(checked);
                  }}
                />
              </td>
            </tr>
            <tr>
              <td className="font-weight-600">Is Tester</td>
              <td>
                <ReactSwitch
                  offColor="#65737b"
                  offHandleColor="#A4B4BD"
                  onColor="#d5e7f4"
                  onHandleColor="#1286C8"
                  width={30}
                  height={16}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  checked={isTester}
                  onChange={(checked) => setIsTester(checked)}
                />
              </td>
            </tr>
            <tr>
              <td className="font-size-16 py-2" colSpan={2}>
                <b>Extension Status</b>
              </td>
            </tr>
            <tr>
              <td className="font-weight-600">Version:</td>
              <td>{showExtensionVersions() || '-'}</td>
            </tr>
            <tr>
              <td className="font-weight-600">Installed:</td>
              <td>{showExtensions('installed', 'uninstallTime') || '-'}</td>
            </tr>
            <tr>
              <td className="font-weight-600">Pinned:</td>
              <td>{showExtensions('pinned', 'unpinnedTime') || '-'}</td>
            </tr>
            <tr>
              <td className="font-weight-600">Logged in:</td>
              <td>{showExtensions('login', 'loggedOutTime') || '-'}</td>
            </tr>
            {showExtensionStatus()}
            <tr>
              <td className="font-size-16 py-2" colSpan={2}>
                <b>Roles</b>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <table>
                  <thead>
                    <tr>
                      <td className="font-weight-600">Role</td>
                      <td className="font-weight-600">Status</td>
                      <td className="font-weight-600">Level</td>
                      <td className="font-weight-600"></td>
                    </tr>
                  </thead>
                  <tbody>
                    {roles.map((role, index) => showRole(role, index))}
                  </tbody>
                </table>
                <RectangularButton
                  className="mt-4 ml-2"
                  onClick={() => {
                    setRoles((roles) => [
                      ...roles,
                      { type: null, status: null, level: 1 },
                    ]);
                  }}
                  lightButton
                >
                  Add role
                </RectangularButton>
              </td>
            </tr>
            <tr>
              <td className="font-size-16 py-2" colSpan={2}>
                <b>Schools</b>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <table>
                  <thead>
                    <tr>
                      <th>School</th>
                      <th className="text-center">Verified</th>
                    </tr>
                  </thead>
                  <tbody>{schools.map(showSchool)}</tbody>
                </table>
                <RectangularButton
                  className="mt-4 ml-2"
                  onClick={() => {
                    setSchools((schools) => [
                      ...schools,
                      { id: '', name: '', isVerified: false },
                    ]);
                  }}
                  lightButton
                >
                  Add school
                </RectangularButton>
              </td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <RectangularButton
          className="mr-3"
          onClick={() => {
            onClose();
            handleSave(user._id, roles, schools, undefined, isTester);
          }}
          disabled={roles.some((r) => !r.type)}
          darkButton
        >
          Save
        </RectangularButton>
      </Modal.Footer>
    </Modal>
  );
}
